import { connect } from 'react-redux';
import { TriggerValidation } from 'app/area/case/draft/action-types';

export const withTriggerValidation = (component: any, uiEngineProps: any) => {
  
  const dispatchToProps = (dispatch: any): any => {
    return {
      triggerValidation: () => dispatch(new TriggerValidation())
    };
  };

  return connect<any, any, any>(undefined, dispatchToProps)(component);
};
